import { render, staticRenderFns } from "./coreValuese.vue?vue&type=template&id=1b081dea&scoped=true&class=carbon"
import script from "./coreValuese.vue?vue&type=script&lang=js"
export * from "./coreValuese.vue?vue&type=script&lang=js"
import style0 from "./coreValuese.vue?vue&type=style&index=0&id=1b081dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b081dea",
  null
  
)

export default component.exports